import { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material'
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import { ButtonBasic, CardTabInfoTicket, CardViewTicket, SelectAbiertoCerradoTicket, SelectFilterStageTicket, SelectMotivoTicket, SelectGenerico } from '../../../components';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import { showModal } from 'react-redux-modal-provider';
import ModalCrearTicketNubicom from '../../../modals/ticket/ModalCrearTicketNubicom';
import ModalCrearTicketNubicomServicio from '../../../modals/ticket/ModalCrearTicketNubicomServicio';

const TabCuentaTicket = ({
    tickets,
    cuenta,
    preservicio,
    nombreCompleto,
    onGuardar,
    servicioNewTk,
    mostrarFiltroServicio = false
}) => {
    const [ticketsView, setTicketsView] = useState([]);
    const [ticketsDisplayed, setTicketsDisplayed] = useState([]);
    const [displayCount, setDisplayCount] = useState(20); // Mostrar 20 inicialmente
    const [contVencidos, setContVencidos] = useState(0);
    const [arrFiltroMotivoTk, setArrFiltroMotivoTk] = useState([]);
    const [filtroIdMotivo, setFiltroIdMotivo] = useState(null);
    const [arrServicios, setArrServicios] = useState([]);
    const [filtroTK, setfiltroTK] = useState('todos');
    const [filtroServicio, setFiltroServicio] = useState(null);
    const observerTarget = useRef(null);

    const onClickTicketNubi = () => {
        if(preservicio){
            showModal(ModalCrearTicketNubicom,{modalNewTk:{ contactoId: preservicio,type: 'nubicom',nombreCompleto,onGuardar:onGuardar}});
        }else if(cuenta){
            showModal(ModalCrearTicketNubicom,{modalNewTk:{ cuentaId: cuenta,type: 'nubicom',nombreCompleto,onGuardar:onGuardar}});
        }
    }
    const onClickTicketNubiServicio = () => {
        showModal(ModalCrearTicketNubicomServicio,{modalNewTk:servicioNewTk, onGuardar:onGuardar});
    }

    // Hook para lazy loading con Intersection Observer
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && displayCount < ticketsView.length) {
                    setDisplayCount(prev => Math.min(prev + 20, ticketsView.length));
                }
            },
            { threshold: 0.1 }
        );

        if (observerTarget.current) {
            observer.observe(observerTarget.current);
        }

        return () => {
            if (observerTarget.current) {
                observer.unobserve(observerTarget.current);
            }
        };
    }, [displayCount, ticketsView.length]);

    // Actualizar tickets mostrados cuando cambia ticketsView o displayCount
    useEffect(() => {
        setTicketsDisplayed(ticketsView.slice(0, displayCount));
    }, [ticketsView, displayCount]);

    // Resetear displayCount cuando cambia ticketsView
    useEffect(() => {
        setDisplayCount(20);
    }, [ticketsView]);

    useEffect(() => {
        if(tickets?.length > 0){
            const tkOrdenados =  tickets?.sort((a, b) => b?.id_tk - a.id_tk);
            setContVencidos(tkOrdenados?.filter((filTk)=> filTk?.estado_tk === 'VENCIDO').length)
            const arrMotivoTk = []
            const arrServicios = []
            tkOrdenados?.forEach(filMt => {
                if(filMt?.cuentaContratoId_txt && !arrServicios.includes(filMt.cuentaContratoId_txt)){
                    arrServicios.push(filMt.cuentaContratoId_txt)
                }
                if(filMt?.tratoId_txt && !arrServicios.includes(filMt.tratoId_txt)){
                    arrServicios.push(filMt.tratoId_txt)
                }
                if(filMt?.id_t && !arrServicios.includes(filMt.id_t)){
                    arrServicios.push(filMt.id_t)
                }
                if(!arrMotivoTk.includes(filMt.motivo_tk)){
                    arrMotivoTk.push(filMt.motivo_tk)
                }
            });
            setArrFiltroMotivoTk(arrMotivoTk)
            setArrServicios(arrServicios)
        }
    }, [tickets])
    useEffect(() => {
        if(tickets?.length > 0){
            let ticketViewFilter = tickets?.sort((a, b) => b?.id_tk - a.id_tk);;
            if(filtroIdMotivo){
                const filtroAct = ticketViewFilter.filter((tk)=> tk?.motivo_tk === filtroIdMotivo)
                ticketViewFilter = filtroAct;
            }else{
                ticketViewFilter = ticketViewFilter;
            }
            if(filtroServicio){
                const filtroAct = ticketViewFilter.filter((tk)=> 
                    tk?.cuentaContratoId_txt === filtroServicio || tk?.tratoId_txt === filtroServicio || tk?.id_t === filtroServicio
                )
                ticketViewFilter = filtroAct;
            }else{
                ticketViewFilter = ticketViewFilter;
            }
            if(filtroTK !== 'todos'){
                if(filtroTK === 'ABIERTO'){
                    const filtroAct = ticketViewFilter.filter((tk)=> !tk?.cerrado_tk)
                    ticketViewFilter = filtroAct;
                }else{
                    const filtroAct = ticketViewFilter.filter((tk)=> tk?.cerrado_tk)
                    ticketViewFilter = filtroAct;
                }
            }else{
                ticketViewFilter = ticketViewFilter;
            }
            setTicketsView(ticketViewFilter)
        }else{
            setTicketsView([])
        }
    }, [tickets,filtroIdMotivo,filtroTK,filtroServicio])
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
                <CardTabInfoTicket
                    texto='Tickets creados'
                    cantidad={tickets?.length ||  0}
                    icon={<ConfirmationNumberOutlinedIcon sx={{color: '#0364ff', fontSize: 40}} />}
                    backgroundIcon='#e6f0ff !important'
                />
            </Grid>
            <Grid item xs={12} sm={5}>
                <CardTabInfoTicket
                    texto='Tickets vencidos'
                    cantidad={contVencidos || 0}
                    icon={<ConfirmationNumberOutlinedIcon sx={{color: '#e53939', fontSize: 40}} />}
                    backgroundIcon='#fce7e7 !important'
                />
            </Grid>
            <Grid item xs={12} sm={2} display='flex' justifyContent='center' alignItems='center'>
                {(cuenta || preservicio) && (
                    <ButtonBasic
                        variant='wk'
                        color='nextStep'
                        textButton='Nuevo Ticket'
                        iconStart={<AddIcon />}
                        fullWidth
                        onClick={()=>onClickTicketNubi()}
                    />
                )}
                {servicioNewTk && (
                    <ButtonBasic
                        variant='wk'
                        color='nextStep'
                        textButton='Nuevo Ticket'
                        iconStart={<AddIcon />}
                        fullWidth
                        onClick={()=>onClickTicketNubiServicio(servicioNewTk)}
                    />
                )}
            </Grid>
            {/* Sección de Filtros Mejorada */}
            <Grid item xs={12}>
                <Box
                    sx={{
                        p: 2,
                        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                        borderRadius: 2,
                        border: '1px solid #e9ecef',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
                    }}
                >
                    <Grid container spacing={1.5} alignItems="flex-end">
                        {/* Título de filtros */}
                        <Grid item xs={12}>
                            <Box display='flex' alignItems='center' gap={1} mb={0.5}>
                                <Box
                                    sx={{
                                        width: 3,
                                        height: 16,
                                        borderRadius: 1,
                                        background: 'linear-gradient(135deg, #0364ff 0%, #02378c 100%)'
                                    }}
                                />
                                <Typography 
                                    sx={{
                                        color: '#15294b', 
                                        fontWeight: 700,
                                        fontSize: 14,
                                        letterSpacing: '0.3px'
                                    }}
                                >
                                    Filtros de búsqueda
                                </Typography>
                            </Box>
                        </Grid>

                        {/* Filtro Servicio */}
                        {mostrarFiltroServicio && (
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography 
                                    sx={{
                                        color: '#6b788e', 
                                        fontSize: 11,
                                        fontWeight: 600,
                                        mb: 0.4,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}
                                >
                                    Servicio
                                </Typography>
                                <Select
                                    isClearable
                                    placeholder="Todos los servicios"
                                    value={arrServicios.map(serv => ({value: serv, label: serv})).find(opt => opt.value === filtroServicio) || null}
                                    onChange={(e) => setFiltroServicio(e?.value || null)}
                                    options={arrServicios.map(serv => ({value: serv, label: serv}))}
                                    styles={customStyles}
                                    menuPortalTarget={document.body}
                                    menuPosition='absolute'
                                    menuPlacement='auto'
                                />
                            </Grid>
                        )}

                        {/* Filtro Tipo */}
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography 
                                sx={{
                                    color: '#6b788e', 
                                    fontSize: 11,
                                    fontWeight: 600,
                                    mb: 0.4,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}
                            >
                                Tipo
                            </Typography>
                            <SelectMotivoTicket
                                isClearable
                                emp='nubicom'
                                value={filtroIdMotivo}
                                onChange={(e)=>setFiltroIdMotivo(e?.value)}
                                filterExist={arrFiltroMotivoTk}
                            />
                        </Grid>

                        {/* Filtro Estado */}
                        <Grid item xs={12} sm={6} md={3}>
                            <Typography 
                                sx={{
                                    color: '#6b788e', 
                                    fontSize: 11,
                                    fontWeight: 600,
                                    mb: 0.4,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}
                            >
                                Estado
                            </Typography>
                            <SelectAbiertoCerradoTicket
                                value={filtroTK}
                                onChange={(e)=>setfiltroTK(e.value)}
                            />
                        </Grid>

                        {/* Resultados */}
                        <Grid item xs={12} sm={6} md={mostrarFiltroServicio ? 3 : 6} display='flex' justifyContent='flex-end' alignItems='center'>
                            <Box
                                sx={{
                                    px: 1.5,
                                    py: 0.6,
                                    background: 'linear-gradient(135deg, #0364ff 0%, #02378c 100%)',
                                    borderRadius: 1.5,
                                    boxShadow: '0 2px 6px rgba(3, 100, 255, 0.2)'
                                }}
                            >
                                <Typography 
                                    sx={{
                                        color: '#fff', 
                                        fontWeight: 700,
                                        fontSize: 13,
                                        textAlign: 'center'
                                    }}
                                >
                                    {ticketsView?.length || '0'} resultado{ticketsView?.length !== 1 ? 's' : ''}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Grid container sx={{border:1, borderColor: '#ebedf0',borderRadius:1}}>
                    <Grid item xs={8} sm={10} p={1.5}>
                        <Typography sx={{color: '#000',fontWeight: 'bold',ml:10}}>Ticket</Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} display='flex' alignItems='center'>
                        <Divider orientation='vertical' sx={{background: '#ebedf0'}} />
                        <Typography sx={{color: '#000',fontWeight: 'bold',textAlign: 'center',ml:4}}>Estado</Typography>
                    </Grid>
                </Grid>
                <Box mb={5}>
                    {ticketsDisplayed?.length > 0 && (
                        ticketsDisplayed.map((tkv)=> <CardViewTicket key={tkv?.id_tk} item={tkv} /> )
                    )}
                    {/* Elemento observador para lazy loading */}
                    {displayCount < ticketsView.length && (
                        <Box 
                            ref={observerTarget}
                            sx={{
                                height: 20,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                my: 2
                            }}
                        >
                            <Typography sx={{ color: '#6b788e', fontSize: 14 }}>
                                Cargando más tickets...
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Grid>
        </Grid>
    )
}

export default TabCuentaTicket